import React from 'react';
import PropTypes from 'prop-types';

function LeftStickBorder({ active, activeColor, color }) {
  return (
    <path
      d="M279.026 393.889C304.833 393.889 325.753 372.969 325.753 347.163C325.753 321.356 304.833 300.436 279.026 300.436C253.22 300.436 232.3 321.356 232.3 347.163C232.3 372.969 253.22 393.889 279.026 393.889Z"
      fill={active ? activeColor : color}
    />
  );
}

LeftStickBorder.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

LeftStickBorder.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#2A2F35',
};

export default LeftStickBorder;
